import React from "react"

export default [
	{
		title: "Быстрый старт",
		description:
			"Интеграция с&nbsp;основными сервисами для бизнеса на&nbsp;тарифах Standard и&nbsp;Pro.",
	},
	{
		title: "Без разработчиков",
		description:
			"Простое подключение в&nbsp;два счета. Но&nbsp;если потребуется, техподдержка будет рядом.",
	},
	{
		title: "Готовые решения",
		description:
			"Всё для масштабирования: готовые каналы продаж и&nbsp;цифровые сервисы от&nbsp;проверенных партнёров.",
	},
]
